import React from 'react';
import {connect} from "react-redux";
import {setCurPage} from '../../actions/filters';
import {setSend,setGotResponse,gotError} from "../../actions/process";
import Button from 'material-ui/Button';
import serverRequest from '../../service/serverRequest';
import {PREV_CONTENT} from "../Pagination";

const PaginationButton=({newPage, paginationEventType, path, handleData, className, filters, user, data, type, dispatch})=>{
    return <Button className={className} onClick={()=>{
            dispatch(setSend());
            dispatch(setCurPage(type, newPage));
            const f = {...filters, path: path, port : filters.port}

            serverRequest(
                f, (code,resp)=>{
                    dispatch(handleData(JSON.parse(resp)));
                    dispatch(setGotResponse('DATE_USERS'));
                }, error=>{dispatch(gotError(error))},
                user, data, paginationEventType, false,
                paginationEventType === PREV_CONTENT ? data.exceptions[0]._id : data.exceptions[data.exceptions.length -1]._id,
                paginationEventType === PREV_CONTENT ? data.exceptions[0].count : data.exceptions[data.exceptions.length -1].count
            );
        }} />
};

const mapStateToProps=(state)=>({filters:state.filters, user: state.user, data: state.data});
const ConnectedPaginationButton=connect(mapStateToProps)(PaginationButton);
export default ConnectedPaginationButton;